import { render } from "./Settings.vue?vue&type=template&id=d21b1b84&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=d21b1b84&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=d21b1b84&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21b1b84"]])

export default __exports__